import { useEffect, useRef, useState } from 'react';
import { updateUserDeposited } from '../../services/UsersService';

function apiError(err) {
    const raw = err?.response ? err.response.data : err?.message;
    if (typeof raw === 'string') return raw;
    if (raw && raw.message) return raw.message;
    return raw ? JSON.stringify(raw) : 'Não foi possível atualizar o capital depositado.';
}

function toInput(value) {
    const number = Number(value);
    if (!Number.isFinite(number)) return '';
    return String(Number(number.toFixed(2)));
}

function formatUsd(value, signed = false) {
    const number = Number(value);
    if (!Number.isFinite(number)) return '0,00';
    const formatted = number.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    if (!signed) return formatted;
    if (number > 0) return `+${formatted}`;
    return formatted;
}

function DepositedModal({ data, onSubmit }) {
    const closeRef = useRef(null);
    const [amount, setAmount] = useState('');
    const [error, setError] = useState('');
    const [saving, setSaving] = useState(false);

    const userId = data?.user?.id || data?.id;
    const walletTotal = Number(data?.walletTotal);
    const currentPnl = Number(data?.pnl);
    const deposited = Number(data?.depositedUsdc ?? data?.allocation);

    useEffect(() => {
        setAmount(toInput(data?.depositedUsdc ?? data?.allocation));
        setError('');
    }, [userId, data?.depositedUsdc, data?.allocation, data?.walletTotal]);

    const parsed = parseFloat(amount);
    const previewPnl = Number.isFinite(parsed) && Number.isFinite(walletTotal)
        ? walletTotal - parsed
        : null;

    function onSave() {
        if (!userId) return;
        if (!Number.isFinite(parsed) || parsed < 0) {
            setError('Informe o capital depositado em USDC, maior ou igual a zero.');
            return;
        }

        setSaving(true);
        setError('');
        updateUserDeposited(userId, parsed)
            .then(result => {
                setSaving(false);
                closeRef.current?.click();
                if (onSubmit) onSubmit(result);
            })
            .catch(err => {
                setSaving(false);
                setError(apiError(err));
            });
    }

    return (
        <div className="modal fade" id="modalDeposited" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <p className="modal-title">Editar capital depositado</p>
                        <button ref={closeRef} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                    </div>
                    <div className="modal-body">
                        <p className="text-muted small mb-3">
                            Não mexe no saldo da carteira. Só altera a base do PnL: quanto o usuário já tinha depositado.
                        </p>
                        <p className="text-muted small mb-3">
                            Carteira: {formatUsd(walletTotal)} USDC
                            {' · '}
                            PnL atual: {formatUsd(currentPnl, true)} USDC
                            {Number.isFinite(deposited)
                                ? ` · Depositado hoje: ${formatUsd(deposited)} USDC`
                                : ''}
                        </p>
                        <div className="mb-3">
                            <label htmlFor="depositedUsdc" className="form-label">Capital depositado (USDC)</label>
                            <input
                                id="depositedUsdc"
                                type="number"
                                min="0"
                                step="0.01"
                                className="form-control"
                                value={amount}
                                onChange={event => setAmount(event.target.value)}
                                placeholder="0.00"
                            />
                            {previewPnl != null
                                ? (
                                    <small className="text-muted d-block mt-1">
                                        PnL passará a {formatUsd(previewPnl, true)} USDC.
                                    </small>
                                )
                                : <></>}
                        </div>
                    </div>
                    <div className="modal-footer">
                        {error
                            ? <div className="alert alert-danger mt-1 col-9 py-1 mb-0">{error}</div>
                            : <></>}
                        <button type="button" className="btn btn-sm btn-primary" onClick={onSave} disabled={saving || !userId}>
                            {saving ? 'Salvando...' : 'Salvar capital'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DepositedModal;
